import { TableRowDto } from '@asset-metrix/portal-gateway-client-js';
import { JsonSchema } from '@sagold/react-json-editor';

import { extractValue } from '../table/extractValue';

function getPointerFromFormat(format: string) {
  return format.split(';')[0];
}

export function getInitialData(schema: JsonSchema, data: TableRowDto['data']) {
  return Object.fromEntries(
    Object.entries(schema.properties ?? {})
      .map(([key, property]) => {
        if (typeof property === 'boolean') {
          return [key, data[key]];
        }

        const pointer =
          (property.format && getPointerFromFormat(property.format)) || key;
        const value = extractValue(pointer, data, true);

        return [
          key,
          property.type === 'array' && !Array.isArray(value)
            ? value === undefined
              ? []
              : [value]
            : value,
        ];
      })
      // Make sure there are no props with undefined values, because they cannot be included in a JSON anyway
      .filter(([, propertyValue]) => propertyValue !== undefined)
  );
}
